export default __webpack_public_path__ + "static/media/rocaSeguroAventura.43ff106a.png";